import { Store, toImmutable } from 'nuclear-js';

import LCActions from './actions';
import DataUtils from '../utils';

import CommonValues from 'resources/common-values';

// the LC data is so large, that it was split into its own store that is not
//    cached in session storage (it was too large for session storage)
export default Store({
    getInitialState() {
        return toImmutable({});
        //<testkey1> :
        //    {
        //       goalStructure: {
        //         childGoals: {<child goals>}
        //         goals: {<parent goals>}},
        //       standardGrades : { <grades> },
        //       statementType: {
        //         id:  <identifier from source>,
        //         StandardTypes: [ 'topic', 'standard']
        //       },
        //       statements: [
        //         {
        //           goalName: "Geometry",
        //           goalkey: 12,
        //           grade: "Grade 6",
        //           group: "standard", // or "topic"
        //           groupDesc: <standard description>,
        //           groupSortOrder: 456,
        //           lsId: "333",
        //           lsName: <ls description>,
        //           lsSortOrder: 567,
        //           maxRit: 225,
        //           minRit: 214,
        //           subGoalId: 3333,
        //           subGoalName: "Analyze patterns"
        //         }
        //       ]
        //     }
    },

    initialize() {
        this.on(LCActions.STORE_LEARNING_CONTINUUM, (state, payload) =>
            storeLearningContinuum(state, payload, DataUtils)
        );
    },
});

export function storeLearningContinuum(state, payload, dataUtils = DataUtils) {
    //transform lcData into a more useful form
    if (!state.has(payload.testkey)) {
        if (!payload.lcData.test) {
            console.warn('While storing data for LC data, there was strangely formatted data', payload.lcData);
            return state;
        }
        const statements = dataUtils.flattenLearningStatements(toImmutable(payload.lcData));
        const standardGrades = toImmutable(
            payload.lcData.standardStatements ? payload.lcData.standardStatements.grades : []
        );
        const type = CommonValues.LearningStatementTypes[payload.lcData.test.learningStatementType];
        const statementType = toImmutable(type ? type : CommonValues.LearningStatementTypes['NONE']);
        const goalStructure = toImmutable(payload.lcData.goalStructure);

        const lcData = toImmutable({
            standardGrades,
            statements,
            statementType,
            goalStructure,
        });

        return state.set(payload.testkey, lcData);
    }

    return state;
}
